import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import Pdf from '../component/pdf';
import HeadPdf from '../component/head-pdf';
import moIndex from '../store';
import Title from '../component/title';
import FootPdf from '../component/foot-pdf';
import './scss/city.scss';
import CityChart from './component/city-chart';
import { isEmpty, round } from 'lodash';
import moDemandPdf from './store';
import getList, { getTableList, isNumbers } from '../store/common';
import CityTable from './component/city-table';

interface IProps {}
interface IState {}

const CityAmount = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { cityRecruitList, cityTime } = moDemandPdf;

  const getResult = useMemo(() => {
    let list: any = [];
    if (!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data)) {
      list = getList(cityRecruitList.data);
    }
    return list;
  }, [cityRecruitList]);

  const getTableResult = useMemo(() => {
    let list: any = [];
    if (!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data)) {
      if (getResult[getResult.length - 1].length === 1){
        list = getTableList(cityRecruitList.data.slice(12), 26);
      } else {
        list = getTableList(cityRecruitList.data, 26);
      }
    }
    return list;
  }, [cityRecruitList]);

  const getTableResult1 = useMemo(() => {
    let list: any = [];
    if (!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data)) {
      list = cityRecruitList.data.slice(0, 12);
    }
    return list;
  }, [cityRecruitList]);

  const cityActive:string = 'num';
  const getMaxList = useMemo(() => {
    let list: any = [];
    let list1: any = [];
    // 获取最大值
    let max: any = '';
    let max1: any = '';
    if (!isEmpty(cityRecruitList?.data)) {
      max =
        !isEmpty(cityRecruitList.data) &&
        cityRecruitList.data[0].amount_current;
      max1 =
        !isEmpty(cityRecruitList.data) && cityRecruitList.data[0].amount_change;
      cityRecruitList?.data.forEach((res: any) => {
        if (res.amount_current > max) {
          max = res.amount_current;
        }
        if (res.amount_change > max1) {
          max1 = res.amount_change;
        }
      });
      list = cityRecruitList?.data?.filter(
        (item: any) => item.amount_current === max,
      );
      list1 = cityRecruitList?.data?.filter(
        (item: any) => item.amount_change === max1,
      );
    }
    return { list, list1 };
  }, [cityRecruitList]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="city-amount">
      {!isEmpty(cityRecruitList) &&
        !isEmpty(cityRecruitList.data) &&
        cityRecruitList.data.length <= 6 && (
        <Pdf>
          <section className="city-pdf-warp">
            <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
            <section className="city-top-title">
              <Title
                title="城市招聘趋势 - 招聘量"
                bigTitle="人力需求"
                tag={isNumbers(cityTime) ? `${cityTime}年` : cityTime}/>
              <p className="details">
              当期：{cityRecruitList.date_period || ''}；上期：{
                  cityRecruitList.last_date_period || ''}
              </p>
              <section className="detail">
                <i>
                  {cityActive === 'salary' ?
                    cityRecruitList?.total_city_data?.salary_previous &&
              round(
                cityRecruitList?.total_city_data?.salary_previous,
                1,
              ).toLocaleString() :
                    cityRecruitList?.total_city_data?.amount_previous &&
              round(
                cityRecruitList?.total_city_data?.amount_previous,
                1,
              ).toLocaleString()}
                </i>
        &nbsp;
                <span>
                  {cityActive === 'salary' ? '上期全国招聘薪酬' : '上期招聘量'}
                </span>
                <i>
                  {cityActive === 'salary' ?
                    cityRecruitList?.total_city_data?.salary_current &&
              round(
                cityRecruitList?.total_city_data?.salary_current,
                1,
              ).toLocaleString() :
                    cityRecruitList?.total_city_data?.amount_current &&
              round(
                cityRecruitList?.total_city_data?.amount_current,
                1,
              ).toLocaleString()}
                </i>
        &nbsp;
                <span>
                  {cityActive === 'salary' ? '当期全国招聘薪酬' : '当期全国招聘量'}
                </span>
                <i>
                  {cityActive === 'salary' ?
                    cityRecruitList?.total_city_data?.salary_change &&
              round(
                cityRecruitList?.total_city_data?.salary_change * 100,
                1,
              ).toLocaleString() :
                    cityRecruitList?.total_city_data?.amount_change &&
              round(
                cityRecruitList?.total_city_data?.amount_change * 100,
                1,
              ).toLocaleString()}
          %
                </i>
        &nbsp;
                <span>
                  {cityActive === 'salary' ?
                    '全国招聘薪酬环比变化率' :
                    '全国招聘量环比变化率'}
                </span>
              </section>
              <CityChart
                cityActive="num"
                index={1}
                show={true}
                list={
                  (!isEmpty(cityRecruitList) && cityRecruitList.data) || []
                }/>
              <CityTable active='num' list={cityRecruitList.data} index={0}/>
              <section className="say-Details">
                <p>解读：</p>
                <p>
                · {!isEmpty(getMaxList?.list) && getMaxList?.list[0].date_tag}
                  {getMaxList?.list?.map((res: any, i: any) => {
                    return <span key={i}>「{res?.city}」</span>;
                  })}
                  {cityActive === 'num' ? '招聘量最高' : '招聘薪酬最高'}
                </p>
                <p>
                · {!isEmpty(getMaxList?.list1) &&
                      getMaxList?.list1[0].date_tag}
                  {getMaxList?.list1?.map((res: any, i: any) => {
                    return <span key={i}>「{res?.city}」</span>;
                  })}
                  {cityActive === 'num' ?
                    '招聘量环比变化率最高' :
                    '招聘薪酬环比变化率最高'}
                </p>
              </section>
            </section>
            <FootPdf />
          </section>
        </Pdf>
      )}

      {!isEmpty(cityRecruitList) &&
        !isEmpty(cityRecruitList.data) &&
        cityRecruitList.data.length > 6 &&
        getResult?.map((res: any, r: any) => {
          return (
            <section key={r}>
              <Pdf>
                <section className="city-pdf-warp">
                  <HeadPdf
                    onetitle="人力资源核心指标"
                    twotitle={moIndex.industry.name}/>
                  <section className="city-top-title">
                    <Title
                      title="城市招聘趋势 - 招聘量"
                      bigTitle="人力需求"
                      tag={isNumbers(cityTime) ? `${cityTime}年` : cityTime}/>
                    <p className="details">
                    当期：{cityRecruitList.date_period || ''}；上期：{
                        cityRecruitList.last_date_period || ''}
                    </p>
                    {r === 0 && <section className="detail">
                      <i>
                        {cityActive === 'salary' ?
                          cityRecruitList?.total_city_data?.salary_previous &&
              round(
                cityRecruitList?.total_city_data?.salary_previous,
                1,
              ).toLocaleString() :
                          cityRecruitList?.total_city_data?.amount_previous &&
              round(
                cityRecruitList?.total_city_data?.amount_previous,
                1,
              ).toLocaleString()}
                      </i>
        &nbsp;
                      <span>
                        {cityActive === 'salary' ? '上期全国招聘薪酬' : '上期招聘量'}
                      </span>
                      <i>
                        {cityActive === 'salary' ?
                          cityRecruitList?.total_city_data?.salary_current &&
              round(
                cityRecruitList?.total_city_data?.salary_current,
                1,
              ).toLocaleString() :
                          cityRecruitList?.total_city_data?.amount_current &&
              round(
                cityRecruitList?.total_city_data?.amount_current,
                1,
              ).toLocaleString()}
                      </i>
        &nbsp;
                      <span>
                        {cityActive === 'salary' ? '当期全国招聘薪酬' : '当期全国招聘量'}
                      </span>
                      <i>
                        {cityActive === 'salary' ?
                          cityRecruitList?.total_city_data?.salary_change &&
              round(
                cityRecruitList?.total_city_data?.salary_change * 100,
                1,
              ).toLocaleString() :
                          cityRecruitList?.total_city_data?.amount_change &&
              round(
                cityRecruitList?.total_city_data?.amount_change * 100,
                1,
              ).toLocaleString()}
          %
                      </i>
        &nbsp;
                      <span>
                        {cityActive === 'salary' ?
                          '全国招聘薪酬环比变化率' :
                          '全国招聘量环比变化率'}
                      </span>
                    </section>}
                    {
                      res.map((item:any, i:any) => {
                        return <section key={i}>
                          <CityChart cityActive="num" list={item} index={i} show={r === 0 && i === 0}/>
                        </section>;
                      })
                    }
                    {res.length === 1 && r === getResult.length - 1 && <CityTable active='num' list={getTableResult1} index={0}/>}
                  </section>
                  <FootPdf />
                </section>
              </Pdf>
            </section>
          );
        })}

      {!isEmpty(cityRecruitList) &&
        !isEmpty(cityRecruitList.data) &&
        cityRecruitList.data.length > 6 &&
        getTableResult.map((res:any, r:any) => {
          return <section key={r}>
            <Pdf>
              <section className="city-pdf-warp">
                <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
                <section className="city-top-title">
                  <Title
                    title="城市招聘趋势 - 招聘量"
                    bigTitle="人力需求"
                    tag={isNumbers(cityTime) ? `${cityTime}年` : cityTime}/>
                  <p className="details">
                    当期：{cityRecruitList.date_period || ''}；上期：{
                      cityRecruitList.last_date_period || ''}
                  </p>
                  <CityTable active='num' list={res} index={getResult[getResult.length - 1].length === 1 ? 1 : r}/>
                  {
                    res.length <= 22 && <section className="say-Details">
                      <p>解读：</p>
                      <p>
                    · {!isEmpty(getMaxList?.list) && getMaxList?.list[0].date_tag}
                        {getMaxList?.list?.map((res: any, i: any) => {
                          return <span key={i}>「{res?.city}」</span>;
                        })}
                        {cityActive === 'num' ? '招聘量最高' : '招聘薪酬最高'}
                      </p>
                      <p>
                    · {!isEmpty(getMaxList?.list1) &&
                          getMaxList?.list1[0].date_tag}
                        {getMaxList?.list1?.map((res: any, i: any) => {
                          return <span key={i}>「{res?.city}」</span>;
                        })}
                        {cityActive === 'num' ?
                          '招聘量环比变化率最高' :
                          '招聘薪酬环比变化率最高'}
                      </p>
                    </section>
                  }
                </section>
                <FootPdf />
              </section>
            </Pdf>
          </section>;
        })
      }
      {!isEmpty(getTableResult) && getTableResult[getTableResult.length - 1].length > 22 &&
        <Pdf>
          <section className="city-pdf-warp">
            <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
            <section className="city-top-title">
              <Title
                title="城市招聘趋势 - 招聘量"
                bigTitle="人力需求"
                tag={isNumbers(cityTime) ? `${cityTime}年` : cityTime}/>
              <p className="details">
              当期：{cityRecruitList.date_period || ''}；上期：{
                  cityRecruitList.last_date_period || ''}
              </p> <section className="say-Details">
                <p>解读：</p>
                <p>
              · {!isEmpty(getMaxList?.list) && getMaxList?.list[0].date_tag}
                  {getMaxList?.list?.map((res: any, i: any) => {
                    return <span key={i}>「{res?.city}」</span>;
                  })}
                  {cityActive === 'num' ? '招聘量最高' : '招聘薪酬最高'}
                </p>
                <p>
              · {!isEmpty(getMaxList?.list1) &&
                    getMaxList?.list1[0].date_tag}
                  {getMaxList?.list1?.map((res: any, i: any) => {
                    return <span key={i}>「{res?.city}」</span>;
                  })}
                  {cityActive === 'num' ?
                    '招聘量环比变化率最高' :
                    '招聘薪酬环比变化率最高'}
                </p>
              </section>
            </section>
            <FootPdf />
          </section>
        </Pdf>
      }
    </section>
  );
};

export default observer(CityAmount);
